import React, { useEffect, useState, useContext, useRef } from "react";

import { Link, useLocation } from "react-router-dom";
import { ContextGlobal } from "../../contexts/ContextGlobal";
import { Oval, ThreeDots } from "react-loader-spinner";
import { set } from "react-hook-form";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export const Registration = () => {

    const { validateRegistration, login, sendResetEmail } = useContext(ContextGlobal);

    const closeRef = useRef(null);
    const [validated, setValidated] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sendEmail, setSendEmail] = useState(false);
    const [message, setMessage] = useState(null);
    const location = useLocation();
    const query = useQuery();

    useEffect(() => {
        setLoading(true);
        async function validateToken(data) {
            const res = await validateRegistration(data); // check for data validity
            if (res) {
                await login({
                    email: data.email,
                    code: res.code,
                });
                setValidated(true);
            } else {
                setValidated(false);
                setMessage("Error with final registration, please try again");
            }
            setLoading(false);
            return true;
        }

        if (location.search !== "") {
            const token = query.get("token");
            const email = query.get("email");
            validateToken({
                code: token,
                email: email,
            });
        } else {
            setLoading(false);
        }
    }, []);

    // send reset password email
    const resetEmail = async (data) => {
        setSendEmail(true);
        const res = await sendResetEmail({
            'email': query.get("email"),
        });
        if (res) {
            setMessage("Email sent, please check your inbox.");
        } else {
            setMessage("Error sending email, please try again.");
        }
        setSendEmail(false);
    };

    useEffect(() => {
        closeRef.current.click();
    }, []);

    return (
        <>
            <div className="d-flex justify-content-center">
                <div className="card" style={{ flex: "0 0 50%" }}>
                    <div className="card-body">
                        {loading ? (
                            <div className="d-flex justify-content-center">
                                <Oval color="#00BFFF" height={150} width={150} />
                            </div>
                        ) : (
                            (() => {
                                switch (validated) {
                                    case false:
                                        return ( 
                                            <>
                                            {/* Re work this messaging depending on the return from the validateRegistration */}
                                                <h1 className="text-center font-weight-bold" style={{color: "#000046"}}>Oops!</h1>
                                                <div className="d-flex justify-content-center">
                                                    {message ? <>{message}</> : <>We apologize but this link has EXPIRED.</>}
                                                </div>
                                                <div className="d-flex justify-content-center mt-4">
                                                    <a href="/" className="btn access-large-button" style={{ flex: "0 1 auto" }}>
                                                        <span className="m-5">HOME</span>
                                                    </a>
                                                </div>
                                            </>
                                        );
                                    case true:
                                        return (
                                            <>
                                                <div className="text-center  p-4" style={{ backgroundColor: "#f8f9fa", border: "2px solid #22cff4", borderRadius: "10px" }}>
                                                    <h1 className="font-weight-bold" style={{color: "#000046"}}>Registration Successful!</h1>
                                                    <p className="mt-4" style={{ fontSize: "18px", color: "#333" }}>
                                                        Congratulations! Your account has been successfully created.
                                                    </p>
                                                    <p style={{ fontSize: "16px", color: "#555" }}>
                                                        You can now explore our reports and services. Start by visiting our <a href="/" target="_blank" rel="noopener noreferrer" className="text-primary font-weight-bold">all products</a> page.
                                                    </p>
                                                    <p style={{ fontSize: "16px", color: "#555" }}>
                                                        <>
                                                            Want to set a password for your account? Click 
                                                            {sendEmail ? <>{" "}<ThreeDots color="#00BFFF" height={20} width={20} wrapperStyle={{ display: "inline" }} />{" "}</> : 
                                                                <>
                                                                    <span onClick={() => {resetEmail()}} style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer", marginLeft: "5px" }}>here</span>{" "}
                                                                </>
                                                            }
                                                            to receive an email to set your password.
                                                            {message ? <p style={{ fontWeight: "bold", fontSize: "16px", color: "#555", marginLeft: "5px" }}>{"**" + message + "**"}</p> : <></>}
                                                        </>
                                                    </p>
                                                    <p style={{ fontSize: "16px", color: "#555" }}>
                                                        Need help? Feel free to <a href="https://www.accumedintel.com/contact/" target="_blank" rel="noopener noreferrer" className="text-primary font-weight-bold">contact us</a> anytime!
                                                    </p>
                                                </div>
                                            </>
                                        );
                                    default:
                                        return (
                                            <>
                                                <h1 className="text-center mt-2">Thanks for signing up!</h1>
                                                <p className="text-center mt-4">Please check your email to confirm your registration.</p>
                                                <p className="text-center">If you don't see the email, please check your spam folder.</p>
                                                <div className="d-flex justify-content-center mt-4">
                                                    <a href="/" className="btn access-large-button" style={{ flex: "0 1 auto" }}>
                                                        <span className="m-5">HOME</span>
                                                    </a>
                                                </div>
                                            </>
                                        );
                                }
                            })()
                        )}
                    </div>
                </div>
            </div>
            <button data-bs-toggle={"modal"} data-bs-target={"#signup"} data-bs-dismiss="modal" style={{ display: "none" }} ref={closeRef}></button>
        </>
    );

}
